/*$(document).ready(function(){
  var w = $(window).width();
  $(function() {
    adjustMenu1();
  });
  $(window).bind('resize orientationchange', function() {
    w = document.body.clientWidth;
    adjustMenu1();
  });
  var adjustMenu1 = function() {
    if (w >= 992) {
      $('.footer-block .footer-block__heading').unbind('click');
      $('.footer-block .footer-block__details-content').show();
      $('.footer-block .footer-block__heading').removeClass('hdactive');
    } else {
      $('.footer-block .footer-block__details-content').hide();
      $('.footer-block .footer-block__heading').unbind('click').bind('click', function(event) {
        if ($(this).next(".footer-block__details-content").css("display") == "none") {
          $('.footer-block .footer-block__details-content').slideUp();
          $('.footer-block .footer-block__heading').removeClass('active');
          $(this).addClass('active');
          $(this).next(".footer-block__details-content").slideDown();
        } else {
          $(this).next(".footer-block__details-content").slideUp();
          $(this).removeClass('active');
        }
      });
    }
  };    
});*/

$('.fetured-slider').slick({
  dots: false,
  nav:true,
  arrow:true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.editorialm-slider').slick({
  dots: true,
  arrows: true,
  infinite: true,
  speed: 300,
   adaptiveHeight: true,
  item: 1
});

//navigation sub-menu open on hover
$('.sub-menu-li, .dropdown-menu').hover(function () {
  var currentclass = $(this).attr('class');
  $(this).addClass('active-inner');
  $(this).parent().parent().addClass('active-menu');
},function () {
  $(this).removeClass('active-inner').delay(1000);
  $(this).parent().parent().removeClass('active-menu').delay(1000);
});

/**/
$('.schadual-slide').slick({
  dots: true,
  nav:true,    
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
}); 

$('.media-slider').slick({
  dots: true,
  arrows: false,
  infinite: true,
  adaptiveHeight: true,
  speed: 300,
  item: 1
});

$(".media-img-modal").on('click', function(){
  var imgUrl = $(this).attr('data-img-src');
  $(".media-popup-content").html('');
  $('.media-popup-content').prepend('<img id="theImg" src="'+imgUrl+'" />');
  $("body").css({"overflow":"hidden"});
  $("#media-modal-show").css({"opacity":1,"visibility":"visible"});
}); 

$(".media-popup-close").on('click', function(){
  $(".media-popup-content").html('');
  $("body").css({"overflow":""});
  $("#media-modal-show").css({"opacity":0,"visibility":"hidden"});
});

$('.gallery-slider').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});
/**/
$(".media-img-modal").on('click', function(){
  var imgUrl = $(this).attr('data-img-src');
   var title = $(this).attr('data-name');
  
    $("#image").val(imgUrl);
  $(".media-popup-content").html('');
  $('.media-popup-content').prepend('<img id="theImg" src="'+imgUrl+'" /><h3 class="clshandle">From The '+title+' Collection</h3>');
  $("body").css({"overflow":"hidden"});
  $("#media-modal-show").css({"opacity":1,"visibility":"visible"});
}); 

$(".media-popup-close").on('click', function(){
  $(".media-popup-content").html('');
  $("body").css({"overflow":""});
  $("#media-modal-show").css({"opacity":0,"visibility":"hidden"});
});
if($(".related-products").length){
  var checkExist = setInterval(function() {
    if($('.related-slider').length) {
      $('.related-slider').slick({
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
          ,
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      clearInterval(checkExist);
    }
  });
}


$(document).ready(function() {
  setPadding();
  $(window).resize(function() {
    setPadding();
  });
});

function setPadding() {
  if($(window).width() <= 1300 && $(window).width() >= 992){
    padding = 65;
  }
  else{
    var padding = 100 - (Math.round($(window).height() * 0.04 + $(window).width() * 0.04));
    if(padding < 60){
      padding = 60;
    }
  }
  $("<style>").text(".blanck { padding:"+padding + "%; }").appendTo("head");
}


$('.mega-menu').bind('mouseenter' ,function(e){
  e.preventDefault();
  var current = $(this).next('.mega-menu');
  $(this).prop('open', true);
  $(".mega-menu__content").css('opacity', '1');
  
});

$('.mega-menu').bind('mouseleave' ,function(e){
  e.preventDefault();
  var current = $(this).next('.mega-menu');
  $(this).prop('open', false);
  $(".mega-menu__content").css('opacity', '0');
});

$( document ).ready(function() {
  $(".details-menu-drawer-submenu").prop('open', true);

  
});

$('.icon-close').bind('click' ,function(e){
  e.preventDefault();

  $("#Details-menu-drawer-container").prop('open', false);
  $("#Details-menu-drawer-container .header__icon").prop("ariaExpanded", false);
  $("#shopify-section-sections--18688000360723__header").removeClass('menu-open');
  $("body").removeClass("overflow-hidden-tablet");
});

/**/
var stylistDD = $('.stylist-dd');
if(stylistDD.length) {
  const label = $('.stylist-dd label');
  const options = $('.stylist-dd li');
  
  // Function to add the active class
  function addActiveClass() {
    if($('.stylist-dd').hasClass('active')){
      $('.stylist-dd').removeClass('active');
    }
    else{
      $('.stylist-dd').addClass('active');
    }
  }
  
  // Function to remove the active class
  function removeActiveClass() {
    $('.stylist-dd').removeClass('active');
  }

  $(document).on("click", ".stylist-dd ul li", function(){
    $(this).parent().parent().addClass('active');
    $(this).parent().parent().find("div").html($(this).find("label").html());
    
    //$(this).parent().parent().find("label").html(<div id='mySecondDiv'></div>");
    //$(this).find("img").css("border-color", "blue");
  });
  
  $(document).on("click", ".stylist-dd ", function(){
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      //$(this).children().css({"height": "auto"});
      //$(this).parent().css({"height": "auto"});
    }
    else{
      $(".stylist-dd").removeClass('active');
      $(this).addClass('active');
    }
  });

  $(document).on('click', function(event){
    var container = $(".stylist-dd");
    if (!container.is(event.target) && container.has(event.target).length === 0){
      removeActiveClass();
    }
  });

  
  // Event listener for label click
  /*  $(document).on("click", ".stylist-dd", function(){//console.log('ewqdsad');
  
  if($(this).hasClass('active')){
      $(this).removeClass('active');
    }
    else{
      $(this).addClass('active');
    }

                                                          
  });
  */
  // Event listener for options click
  $(document).on("click", "stylist-dd li", function(){
    const selectedOption = $(this).html();
    label.html(selectedOption);
  });

  // Event listener for outside click
 /* document.addEventListener('click', event => {
    const target = event.target;
    if (!stylistDD.contains(target)) {
      removeActiveClass();
    }
  });*/
}

$(".sorting-options2").on('click', function(){
  var sortVal = $(this).attr('data-value');
  $('.facet-filters__sort option[value='+sortVal+']').attr('selected','selected');
  $('.facet-filters__sort').trigger('change');
});


$(".scroll-content li a").click(function (event) {
  event.preventDefault();
  var thisID = $(this).attr('data-id');
  $('html,body').animate({scrollTop:$("#"+thisID).offset().top});
});

$('.sub-menu-hover-link').hover(function () {
  var index = $(this).attr('data-menuindex');
  var linkImg = $(this).attr('data-menu-image');
  if(linkImg != ''){
    $(".sub-menu-img-"+index).attr('src', linkImg);
  }
});

$('.sub-menu-hover-link').on( "mouseleave", function() {
  var index = $(this).attr('data-menuindex');
  var parentIndex = $(this).attr('data-parentindex');
  var defaultImg = $(".parentImage-"+parentIndex).val();
  if(defaultImg != ''){
    $(".sub-menu-img-"+index).attr('src', defaultImg);
  }
});

$(document).ready(function(){
  $('.parent_menu').each(function(i, obj) {
    var attr = $(this).attr('data-non-child');
    if (typeof attr !== 'undefined' && attr !== false) {
      $("#paremt-menu-show-"+attr).addClass('non-child-menu-items');
      $(".custom-mm-column-"+attr).removeClass('multi-column-menu');
    }
  });
});
$('video').autoplay = true;
$('video').load();
/*
  var media = document.querySelectorAll(`.deferred-media`);
          if (media.length) {
            media.forEach((fs,index) => {
                    //media.loadContent(true);
console.log("index"+index);
              $(".deferred-media").attr("loaded", true);
            });
          }*/